<button [ngClass]="buttonClasses" (click)="onClick()" [disabled]="disabled ? true: null">
  @if(type === 'floating') {
    <img [src]="'assets/icons/' + icon + '.svg'" alt="icon" class="button-icon" />
  }
 <ng-content></ng-content>
</button>